// SPDX-License-Identifier: AGPL-3.0-or-later
import {NativeDragRegion} from '@app/features/app/components/layout/NativeDragRegion';
import styles from '@app/features/channel/components/ChannelHeader.module.css';
import {clsx} from 'clsx';
import type {ComponentProps} from 'react';

export function ChannelHeaderSurface({className, ...props}: ComponentProps<typeof NativeDragRegion>) {
	return <NativeDragRegion {...props} className={clsx(styles.headerContainer, className)} />;
}
